<script>
  import { handleMicSuccess } from "./js/mic-stream";
  import { onMount } from "svelte";
  import Slider from "./Slider.svelte";

  function setup() {
    const player = document.getElementById("player");
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(handleMicSuccess(player));
  }
  onMount(setup);
</script>

<style>
  audio {
    display: none;
  }
  :global(html, body) {
    margin: 0;
    padding: 0;
    height: 100%;
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
  .title {
    text-align: center;
    position: relative;
    padding: 2rem;
    margin-top: 10rem;
  }
  .title * {
    z-index: 1;
  }
  .title::before {
    content: "";
    background: rgb(230, 230, 230);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    border-radius: 10px;
  }

  .imgwrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  img[src="favicon.png"] {
    width: auto;
    height: 200px;
  }
</style>

<main>
  <div class="container">
    <div class="title">
      <h1>Tired of people speaking to you?</h1>
      <h3>Or just want some peace and quite...</h3>
      <br />
      <p>
        If there is a noise level which goes above the noise threshold you set,
        this web app screams "Shut Up"
      </p>
    </div>
    <div style="display: block">
      <br />
      <br />
      <br />
      <p>Adjust how moody you are! (Change the noise threshold)</p>
      <br />
      <Slider />
      <br />
      <div class="imgwrapper">
        <img src="favicon.png" alt="favicon" />
      </div>
    </div>
  </div>

  <audio id="player" controls>
    <source src="static/shutup.swf.mp3" />
  </audio>
</main>
